import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './EmployeeTable.css';
import './tablestyle.css';

const DesignationTable = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [payList, setPayList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();

  const fetchPayList = () => {
    setLoading(true);
    fetch(`${baseUrl}/getUserDesign`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status && Array.isArray(data.data)) {
          setPayList(data.data);
        } else {
          setPayList([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching Designation list:', err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchPayList();
  }, []);

  const handleEditClick = (id) => {
    navigate(`/designation/edit/${id}`);
  };

  const handleDeleteClick = async (id) => {
    if (!window.confirm('Are you sure you want to delete this Designation?')) return;

    try {
      const response = await fetch(`${baseUrl}/deleteUserDesignModeById/${id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });

      const result = await response.json();

      if (result.status) {
        alert('Designation deleted successfully!');
        fetchPayList();
      } else {
        alert(result.message || 'Failed to delete Designation.');
      }
    } catch (error) {
      console.error('Error deleting Designation:', error);
      alert('An error occurred while deleting.');
    }
  };

  // Filtering logic
  const filteredData = payList.filter((item) =>
    Object.values(item)
      .join(' ')
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  // Pagination logic
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = filteredData.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <div>Loading Designation data...</div>;

  return (
    <div className="employee-table-container" style={{padding: "10px"}}>

      {/* Top Controls */}
      {/* Top Controls */}
<div
  className="table-controls"
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px',
    flexWrap: 'wrap',
    gap: '10px',
    background: '#f9f9f9',
    padding: '10px 15px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
  }}
>
  {/* Show entries */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', fontWeight: 500 }}>
    Show{' '}
    <select
      value={itemsPerPage}
      onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
      style={{
        padding: '5px 8px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        outline: 'none',
        cursor: 'pointer',
      }}
    >
      <option value={10}>10</option>
      <option value={50}>50</option>
      <option value={100}>100</option>
    </select>{' '}
    entries
  </div>

  {/* Search */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', fontWeight: 500 }}>
    Search:
    <input
      type="text"
      value={search}
      onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
      placeholder="Search Designation..."
      style={{
        padding: '5px 10px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        outline: 'none',
        minWidth: '180px',
        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
        transition: 'border 0.2s, box-shadow 0.2s',
      }}
      onFocus={(e) => e.target.style.boxShadow = '0 0 5px rgba(0,123,255,0.5)'}
      onBlur={(e) => e.target.style.boxShadow = 'inset 0 1px 3px rgba(0,0,0,0.05)'}
    />
  </div>
</div>

      {/* Table */}
      <table className="employee-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Designation</th>
            <th>Status</th>
            <th>Created By</th>
            <th>Created On</th>
            <th>Modified By</th>
            <th>Modified On</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentData.length > 0 ? (
            currentData.map((item, index) => (
              <tr key={item.id}>
                <td>{startIndex + index + 1}</td>
                <td>{item.designation_type}</td>
                <td>
                  <span className={`status-badge ${item.status === 'A' ? 'active' : 'inactive'}`}>
                    {item.status === 'A' ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>{item.created_by}</td>
                <td>{item.created_on}</td>
                <td>{item.modified_by || '-'}</td>
                <td>{item.modified_on || '-'}</td>
                <td>
                  <button className="action-button edit" onClick={() => handleEditClick(item.id)}>Edit</button>
                  <button className="action-button delete" onClick={() => handleDeleteClick(item.id)}>Delete</button>
                </td>
              </tr>
            ))
          ) : (
            <tr><td colSpan="8" style={{ textAlign: 'center' }}>No Designation data found</td></tr>
          )}
        </tbody>
      </table>

      {/* Bottom Controls */}
      <div className="table-footer" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
        {/* Showing entries */}
        <div>
          Showing {currentData.length > 0 ? startIndex + 1 : 0} to {startIndex + currentData.length} of {totalItems} entries
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>{'<'}</button>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => handlePageChange(i + 1)}
              style={{ fontWeight: currentPage === i + 1 ? 'bold' : 'normal' }}
            >
              {i + 1}
            </button>
          ))}
          <button disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>{'>'}</button>
        </div>
      </div>

    </div>
  );
};

export default DesignationTable;
